import React from 'react'
import { CountryCodeISO } from '../../utils/phone-utils'

import ruFlag from '../../assets/flags/ru.svg'
import kzFlag from '../../assets/flags/kz.svg'
import byFlag from '../../assets/flags/by.svg'
import uzFlag from '../../assets/flags/uz.svg'
import azFlag from '../../assets/flags/az.svg'

const flagsMap: { [K in CountryCodeISO]: string } = {
    'RU': ruFlag,
    'KZ': kzFlag,
    'BY': byFlag,
    'UZ': uzFlag,
    'AZ': azFlag,
}

export const CountryFlag: React.FC<{ country: CountryCodeISO }> = ({ country }) => {
    return (
        <img
            width="20"
            src={flagsMap[country]}
            alt={`${country} flag`}
        />
    )
}
